import React, { ReactElement } from 'react'
import ChessContentItem from './ChessContentItem'

import styles from '@corratech/pylot-custom-widgets/ChessContent/ChessContent.module.scss'

type WidgetConfig = {
    enabled: boolean
    widgetConfiguration: { [key: string]: string }
    children?: ReactElement[]
    html?: string
}

export type DataAttributes = Record<string, string>

const extractDataAttributes = (element: Element): DataAttributes => {
    if (!element) return {}

    const dataAttributes: DataAttributes = {}

    Array.from(element.attributes).forEach((attr) => {
        if (attr.name.startsWith('data-')) {
            // convert data attribute name to snake_case (excluding 'data-' prefix)
            const key = attr.name.replace(/^data-/, '').replace(/-/g, '_')

            // remove leading "w_" if present
            const cleanKey = key.replace(/^w_/, '')

            dataAttributes[cleanKey] = attr.value
        }
    })

    return dataAttributes
}

const MainContent = ({
    content,
    heading,
    image
}: WidgetConfig['widgetConfiguration']): ReactElement | null => (
    <>
        {image && (
            <div className={styles['content-image']}>
                <img src={image} alt={heading || ''} loading="lazy" />
            </div>
        )}
        {heading && <h2 className={styles['content-header']}>{heading}</h2>}
        {content && <div className={styles['content-subtitle']}>{content}</div>}
    </>
)

const ChessContent = (props: WidgetConfig): ReactElement => {
    const { widgetConfiguration, enabled, html } = props

    const renderFromRawHtml = (htmlString: string) => {
        if (typeof window === 'undefined') {
            return []
        }

        const parser = new DOMParser()
        const doc = parser.parseFromString(htmlString, 'text/html')

        const items = doc.getElementsByClassName('chess-content-item')

        return Array.from(items).map((item) => {
            const itemConfig = extractDataAttributes(item)
            if (itemConfig?.element !== 'widget_content') {
                itemConfig.content = item.getElementsByTagName(
                    'p'
                )?.[0]?.innerHTML

                if (itemConfig.enabled == 'false') {
                    return
                }

                return <ChessContentItem {...itemConfig} />
            }
        })
    }

    const WidgetItems = html ? renderFromRawHtml(html) : null

    if (!enabled) {
        return <></>
    }

    return (
        <div className={styles['chess-content']}>
            <div className={styles['main-content']}>
                <MainContent {...widgetConfiguration} />
            </div>
            {WidgetItems}
        </div>
    )
}

export default ChessContent
